__turbopack_context__.v({
  "chartContainer": "chart-module-scss-module__5nbbJa__chartContainer",
  "chartMapContainer": "chart-module-scss-module__5nbbJa__chartMapContainer",
});
